/**
 * @author NikolaV
 */
import { fitExtent, pointsToEN } from '@openlayers/ol-utils';
import { store } from '../store/rootStore';
import { GeofenceEditor } from './GeofenceEditor';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Polygon as OlPolygon } from 'ol/geom';
import OlOverlay from 'ol/Overlay';
import OlLayer from 'ol/layer/Layer';
import OlMap from 'ol/Map';
import Feature from 'ol/Feature';
import { mapWrapper } from '@pages/trucks/TrucksMap';
import { GeofenceFeatureFactory } from '@shared/trucks/GeofenceFeatureFactory';


let mapInstance: OlMap = null;
let initialLoad = true;
const labels: OlOverlay[] = [];

export const source: VectorSource = new VectorSource({
    features: [],
    useSpatialIndex: true,
});

export const layer: OlLayer = new VectorLayer({
    source,
    updateWhileAnimating: true,
    updateWhileInteracting: true,
});

export function clear() {
    source.clear(false);
    labels.forEach(l => mapInstance.removeOverlay(l));
}

export function makeFeatures(map: OlMap) {
    mapInstance = map;

    clear();
    if (initialLoad) {
        mapInstance.addLayer(layer);
        initialLoad = false;
    }

    for (const geofence of store.geofences.items) {
        let polyFeature: Feature;

        try {
            const geometry = geofence.geometry;
            const latLons: IPoint[] = geometry.split(',').map(ll => {
                const parts = ll.trim().split(' ');

                return {
                    lat: parseFloat(parts[0]),
                    lon: parseFloat(parts[1]),
                };
            });

            const coords: Coordinate[] = pointsToEN(latLons);

            polyFeature = new Feature({
                geometry: new OlPolygon([coords]),
            });
            polyFeature.setId(geofence.id);
            polyFeature.set('type', 'geofence');
            polyFeature.set('data', geofence);
            polyFeature.setStyle(GeofenceFeatureFactory.styles.normal[geofence.type]);
        } catch (e) {
            console.log(e);
            geofence.error = 'Invalid geofence coordinates';
            continue;
        }

        source.addFeature(polyFeature);

        // label 
        if (!store.showGeofenceNamesOnMap) continue;
        const $textElem = $(`<div class="measure-label" style="color: black">
<div class="flex-row ai-center">${geofence.title} <i class="iki iki-edit js-geofence-edit" data-geofence-id="${
            geofence.id
        }"></i></div></div>`);

        const label = new OlOverlay({
            element: $textElem[0] as HTMLDivElement,
            positioning: 'center-center',
            stopEvent: false,
        });

        labels.push(label);
        mapInstance.addOverlay(label);
        label.setPosition((polyFeature.getGeometry() as OlPolygon).getInteriorPoint().getCoordinates());
        mapInstance.getView().dispatchEvent('change:resolution');
    }

    $('.js-geofence-edit').off().click(e => {
        e.stopPropagation();
        const { geofenceId } = (e.currentTarget as HTMLElement).dataset;
        const geofence = store.geofences.items.find(g => g.id === parseInt(geofenceId));
        const initialFeature = source.getFeatureById(geofence.id);
        if (geofence) {
            GeofenceEditor.open(mapWrapper, store.geofences, store.materials, geofence.uuid, initialFeature);
        }
    });
}

export function fitById(geofenceId: number) {
    const f: Feature = source.getFeatureById(geofenceId);
    if (f) fitExtent(mapInstance, f.getGeometry().getExtent(), 250);
}

export function hideLabels() {
    labels.forEach(l => (l.getElement().style.display = 'none'));
}

export function showLabels() {
    labels.forEach(l => (l.getElement().style.display = 'block'));
}
